import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travelagentsinpuneforminibushire() {



  const cardData = {
"keyword": "Travel Agents in Pune for Mini Bus Hire",

"headingDescription":
  "Aaradhya Travels offers reliable mini bus hire services in Pune through experienced travel coordination for group transportation including corporate travel, weddings, school trips, college tours, pilgrimage journeys, and outstation tours. We provide well-maintained AC and non-AC minibuses with professional drivers, flexible booking options, and affordable pricing for safe and comfortable group travel across Pune and Maharashtra.",

"topPlaces": [
{
"title": "Amboli",
"description":
"Amboli is a hill station in the Sahyadri range famous for waterfalls, mist, and green valleys. It is ideal for nature and monsoon group tours from Pune."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular long-road group travel destination from Pune."
},
  {
"title": "Ellora Caves",
"description":
"Ellora Caves is a UNESCO World Heritage site near Aurangabad famous for rock-cut temples, sculptures, and ancient Indian architecture. It is a popular long-distance group travel destination from Pune for history and heritage tours."
},
{
"title": "Ajanta Caves",
"description":
"Ajanta Caves are UNESCO-listed Buddhist caves known for ancient paintings, carvings, and historical significance. It is a top cultural and heritage group tour destination from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for viewpoints, toy train rides, and lush greenery. It is ideal for peaceful group trips from Pune."
},
{
"title": "Harihareshwar",
"description":
"Harihareshwar is a coastal pilgrimage and beach destination known as 'Dakshin Kashi'. It is popular for temple visits, beaches, and group tours from Pune."
},
{
"title": "Diveagar",
"description":
"Diveagar is a clean and less crowded beach destination known for coconut trees, calm waters, and peaceful group outings from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a scenic hill station known for Arthur Lake, Randha Falls, and beautiful monsoon views. It is a popular weekend group trip destination from Pune."
},
{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city known for lakeside promenade, colorful architecture, cafes, and leisure activities. It is a popular short group trip destination from Pune."
},
{
"title": "Karnala Bird Sanctuary",
"description":
"Karnala Bird Sanctuary is a protected forest area near Mumbai known for trekking, birdwatching, and nature trails. It is ideal for adventure group trips from Pune."
}
],



services: [
  {
    name: "Tour Agencies in Pune",
    description: "Tour agencies in Pune provide reliable transportation and travel solutions for family vacations, pilgrimage journeys, sightseeing tours, corporate outings, and group travel requirements. Comfortable buses, tempo travellers, and luxury vehicles ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs and travel coordinators ensure safe journeys and dependable services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient tour package reservations."
  },
  {
    name: "Bus Hire Agency in Pune",
    description: "Bus hire agency in Pune service offers dependable transportation solutions for weddings, educational tours, airport transfers, office outings, family functions, and outstation journeys. Spacious buses and experienced drivers ensure comfortable travel experiences suitable for local and long-distance travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Tourist Agency in Pune",
    description: "Tourist agency in Pune provides comfortable transportation and travel planning services for sightseeing journeys, pilgrimage tours, holiday vacations, educational trips, and family outings. Spacious vehicles and professional travel services ensure pleasant travel experiences suitable for tourist and group passengers. Experienced chauffeurs ensure safe transportation and dependable pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient tourist travel reservations."
  },
  {
    name: "Travel Agents in Pune",
    description: "Travel agents in Pune offer reliable transportation and travel management solutions for corporate tours, family vacations, pilgrimage journeys, airport transfers, and sightseeing travel. Comfortable buses and tempo travellers ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient travel reservations."
  },
  {
    name: "Pune Tours and Travels Agents",
    description: "Pune tours and travels agents provide dependable travel solutions for educational tours, family vacations, wedding travel, pilgrimage journeys, and business travel requirements. Spacious vehicles and professional travel planning ensure comfortable journeys suitable for local and outstation travel. Professional drivers ensure safe transportation and reliable pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient tours and travels reservations."
  },
  {
    name: "Bus Hire Agents in Pune",
    description: "Bus hire agents in Pune service offers affordable and comfortable transportation solutions for school trips, office outings, tourist travel, weddings, and family functions. Spacious buses ensure smooth travel experiences suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "Best Traveller Bus on Rent in Pune",
    description: "Best traveller bus on rent in Pune service provides premium transportation for sightseeing journeys, airport transfers, family vacations, corporate travel, and outstation tours. Spacious seating and comfortable interiors ensure pleasant travel experiences suitable for medium and large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient traveller bus reservations."
  },
  {
    name: "Urbania Bus on Rent in Pune for Corporate Outing",
    description: "Urbania bus on rent in Pune for corporate outing service offers luxurious transportation for office trips, employee outings, team-building activities, conferences, and business travel requirements. Spacious luxury interiors ensure comfortable travel experiences suitable for corporate teams and executive passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient Urbania bus reservations."
  },
  {
    name: "Travel Agents in Pimpri Chinchwad",
    description: "Travel agents in Pimpri Chinchwad provide dependable travel and transportation solutions for airport transfers, educational tours, family vacations, pilgrimage journeys, and tourist travel. Spacious buses and tempo travellers ensure comfortable journeys suitable for local and outstation travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient travel reservations."
  },
  {
    name: "Pune Travel Agency Contact Number",
    description: "Pune travel agency contact number service provides quick and reliable travel assistance for bus bookings, tempo traveller reservations, airport transfers, tour packages, and group travel planning. Comfortable vehicles and experienced travel coordinators ensure smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient travel reservations."
  },
  {
    name: "Bus Hire for Events Agency",
    description: "Bus hire for events agency service offers dependable transportation for exhibitions, conferences, weddings, cultural programs, office gatherings, and special event travel requirements. Spacious buses ensure comfortable travel experiences suitable for medium and large passenger groups. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the event schedule. Pickup services are available from homes, banquet halls, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient event bus reservations."
  },
  {
    name: "Bus Hire for Corporate Events and Tours",
    description: "Bus hire for corporate events and tours service provides professional transportation for conferences, seminars, office outings, industrial visits, business meetings, and employee travel. Spacious buses and comfortable seating ensure smooth travel experiences suitable for executive teams and corporate groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Bus Booking for Corporate Events",
    description: "Bus booking for corporate events service offers premium transportation solutions for office functions, employee travel, business conferences, exhibitions, and team outings. Spacious buses ensure comfortable seating and smooth journeys suitable for corporate teams and business passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, IT parks, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate event bus reservations."
  },
  {
    name: "Pune to Mahabaleshwar Package Tour Bus",
    description: "Pune to Mahabaleshwar package tour bus service provides comfortable hill station transportation for sightseeing tours, family vacations, educational trips, and group travel from Pune. Spacious buses and smooth ghat road travel ensure pleasant travel experiences suitable for tourists and families. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar bus package reservations."
  },
  {
    name: "Pune to Shirdi Tour Package Bus",
    description: "Pune to Shirdi tour package bus service offers reliable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Pune. Spacious buses ensure smooth highway travel suitable for devotees, tourist groups, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi tour bus reservations."
  },
  {
    name: "Pune to Goa Tour Package Bus",
    description: "Pune to Goa tour package bus service provides comfortable long-distance transportation for beach vacations, sightseeing tours, bachelor trips, family holidays, and tourist travel from Pune. Spacious buses ensure smooth highway journeys suitable for all passenger groups and luggage requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Goa tour bus reservations."
  },
  {
    name: "Pune Darshan Bus Package",
    description: "Pune Darshan bus package service offers reliable transportation for city sightseeing tours, educational visits, tourist travel, and family outings across Pune attractions. Spacious buses ensure comfortable seating suitable for local travel and group tour requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Pune Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and commercial areas across Pune. Flexible booking options allow convenient Pune Darshan package reservations."
  },
  {
    name: "Corporate Travel Agency Pune",
    description: "Corporate travel agency Pune service provides professional transportation and travel management solutions for employee movement, business meetings, conferences, office outings, and executive travel. Spacious buses and luxury vehicles ensure comfortable travel experiences suitable for corporate teams and business passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate travel reservations."
  },
  {
    name: "Wedding Bus Booking Agency Pune",
    description: "Wedding bus booking agency Pune service offers luxurious transportation for marriage ceremonies, bridal parties, guest travel, family gatherings, and wedding event requirements. Spacious buses and elegant interiors ensure smooth travel experiences suitable for wedding celebrations and family functions. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Outstation Tour Operators Pune",
    description: "Outstation tour operators Pune service provides reliable transportation and travel planning for Goa trips, Konkan Darshan, Mahabaleshwar tours, pilgrimage journeys, and tourist travel from Pune. Spacious buses and tempo travellers ensure comfortable long-distance travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation tour reservations."
  },
  {
    name: "Tempo Traveller Booking Agency Pune",
    description: "Tempo Traveller booking agency Pune service offers comfortable transportation solutions for family vacations, airport transfers, educational tours, wedding travel, and outstation journeys. Spacious tempo travellers ensure smooth travel experiences suitable for medium-sized passenger groups and tourist travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient tempo traveller reservations."
  }
],

tableData: [
  ["Tour Agencies in Pune", "Bus Hire Agency in Pune"],
  ["Tourist Agency in Pune", "Travel Agents in Pune"],
  ["Pune Tours and Travels Agents", "Bus Hire Agents in Pune"],
  ["Best Traveller Bus on Rent in Pune", "Urbania Bus on Rent in Pune for Corporate Outing"],
  ["Travel Agents in Pimpri Chinchwad", "Pune Travel Agency Contact Number"],
  ["Bus Hire for Events Agency", "Bus Hire for Corporate Events and Tours"],
  ["Bus Booking for Corporate Events", "Pune to Mahabaleshwar Package Tour Bus"],
  ["Pune to Shirdi Tour Package Bus", "Pune to Goa Tour Package Bus"],
  ["Pune Darshan Bus Package", "Corporate Travel Agency Pune"],
  ["Wedding Bus Booking Agency Pune", "Outstation Tour Operators Pune"],
  ["Tempo Traveller Booking Agency Pune", "Tour Agencies in Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Travel Agents in Pune for Mini Bus Hire",
        WhyChoosedescription: "Aaradhya Travels provides reliable mini bus hire services in Pune with professional travel support, comfortable vehicles, and smooth transportation arrangements for family tours, corporate trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Mini Bus Hire Packages in Pune",
        WhyChoosedescription: "Aaradhya Travels offers affordable mini bus hire packages in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking Assistance",
        WhyChoosedescription: "Our travel agents in Pune are available 24 hours for mini bus booking services including airport transfers, wedding transportation, school tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Well-Maintained Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Planning",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, corporate outings, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, and larger mini buses suitable for family groups, corporate teams, schools, and tourists."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Pune Airport, railway stations, hotels, homes, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Pimpri, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Group Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What are travel agents in Pune for mini bus hire?", answer: "Travel agents in Pune for mini bus hire provide comfortable group transportation services for corporate travel, family trips, weddings, school tours, and outstation journeys." },
    { question: "Is mini bus hire booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus hire booking service in Pune." },
    { question: "Which seating capacity mini buses are available?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, 25 seater, 32 seater, and larger mini bus options for group travel." },
    { question: "Can I book mini buses for outstation travel?", answer: "Yes, customers can book mini buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide mini buses for corporate events?", answer: "Yes, Aaradhya Travels provides mini bus hire services for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are AC and Non-AC mini buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly group travel." },
    { question: "Can I book mini bus hire service online in Pune?", answer: "Yes, customers can easily book mini bus hire service online or through phone booking." },
    { question: "Do you provide mini buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for weddings, family vacations, and group tours." },
    { question: "Are mini bus hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for mini bus hire service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "Group travel in Pune became very convenient with Aaradhya Travels providing a mini bus hire service. The journey was smooth, and everyone could travel together comfortably without any coordination issues.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Aaradhya Travels arranged a mini bus hire service in Pune for our family outing, and everything was well managed. The vehicle was clean, spacious, and made the travel experience comfortable for everyone.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Travel Agents in Pune for Mini Bus Hire",
  "image": "https://www.aaradhyatravels99.com/assets/images/travel-agents-mini-bus-hire-pune.jpg",
  "description": "Book mini bus and tempo traveller through trusted travel agents in Pune with Aaradhya Travels. We provide bus hire services for corporate events, weddings, airport transfers, tours, and outstation trips including Urbania, mini buses, and luxury coaches.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3127"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/travel-agents-in-pune-for-mini-bus-hire"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Travel Agents in Pune for Mini Bus Hire | Bus Booking & Tours | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire mini bus and luxury coach through trusted travel agents in Pune with Aaradhya Travels. We provide bus booking for corporate tours, weddings, airport transfers, group travel, and outstation trips across Pune and Pimpri Chinchwad."
  />

  <meta
    name="keywords"
    content="Tour Agencies In Pune, Bus Hire Agency in Pune, Tourist agency in Pune, Travel agents in Pune, Pune tours and travels agents, Bus hire agents in Pune, Best traveller bus on rent in Pune, Urbania bus on rent in Pune for corporate outing, Travel Agents in Pimpri Chinchwad, Pune travel agency contact number, Bus hire for events agency, Bus hire for corporate events & tours, Bus booking for corporate events"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Travelagentsinpuneforminibushire;